const MOBILE_PARTNERS_MEDIA_QUERY = window.matchMedia("(max-width: 599px)");
const COLLAPSED_LABEL = "Ver todos os parceiros";
const EXPANDED_LABEL = "Ver menos";
const ANIMATION_DURATION = 260;

function animateParentContainer($section, expand) {
  const $content = $section.find("[data-partners-animated-content]");

  if (!$content.length) {
    if (expand) {
      $section.addClass("partners-expanded");
    } else {
      $section.removeClass("partners-expanded");
    }
    return;
  }

  const fromHeight = $content.outerHeight();

  if (expand) {
    $section.addClass("partners-expanded");
  } else {
    $section.removeClass("partners-expanded");
  }

  const toHeight = $content.outerHeight();

  $content
    .stop(true, true)
    .css({ height: fromHeight, overflow: "hidden" })
    .animate({ height: toHeight }, ANIMATION_DURATION, () => {
      $content.css({ height: "", overflow: "" });
    });
}

function syncPartnersSectionState($section) {
  const isMobile = MOBILE_PARTNERS_MEDIA_QUERY.matches;
  const $toggle = $section.find("[data-partners-toggle]");

  if (!$toggle.length) {
    return;
  }

  if (!isMobile) {
    $section.removeClass("partners-expanded");
  }

  const isExpanded = isMobile && $section.hasClass("partners-expanded");
  $toggle.attr("aria-expanded", String(isExpanded));
  $toggle
    .find(".partners-toggle-label")
    .text(isExpanded ? EXPANDED_LABEL : COLLAPSED_LABEL);
}

export function initMobilePartnersToggle() {
  const $sections = $(".partners[data-mobile-toggle='true']");

  if (!$sections.length) {
    return;
  }

  $sections.each((_, element) => {
    const $section = $(element);
    const $toggle = $section.find("[data-partners-toggle]");

    $toggle.off("click.partnersToggle").on("click.partnersToggle", () => {
      if (!MOBILE_PARTNERS_MEDIA_QUERY.matches) {
        return;
      }

      const isExpanded = $section.hasClass("partners-expanded");

      animateParentContainer($section, !isExpanded);

      $toggle.attr("aria-expanded", String(!isExpanded));
      $toggle
        .find(".partners-toggle-label")
        .text(isExpanded ? COLLAPSED_LABEL : EXPANDED_LABEL);
    });

    syncPartnersSectionState($section);
  });

  if (window.__quitejaPartnersToggleBound) {
    return;
  }

  const handleViewportChange = () => {
    $sections.each((_, element) => {
      syncPartnersSectionState($(element));
    });
  };

  if (typeof MOBILE_PARTNERS_MEDIA_QUERY.addEventListener === "function") {
    MOBILE_PARTNERS_MEDIA_QUERY.addEventListener(
      "change",
      handleViewportChange,
    );
  } else {
    MOBILE_PARTNERS_MEDIA_QUERY.addListener(handleViewportChange);
  }

  window.__quitejaPartnersToggleBound = true;
}
